import React, { useContext, useEffect, useState } from 'react';
import FetchAreasService from './FetchAreasService';

export const AreaPicker = ({ resources, selectedArea, setSelectedArea,token }) => {
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    fetchAreas();
  }, []);

  const fetchAreas = async () => {
    try {
      const response = await FetchAreasService(token);
      console.log('Areas fetched:', response);
      const areaNames = response.map((area, index) => ({
        id: index,
        name: area.name,
      }));
      setAreas(areaNames);
    } catch (error) {
      console.error('Failed to fetch areas:', error);
    }
  };

  return (
    <div style={styles.container}>
      <label htmlFor="area-select" style={styles.label}>Choose an Area</label>
      <select
        id="area-select"
        value={selectedArea || ''}
        onChange={(e) => setSelectedArea(e.target.value)}
        style={styles.select}
      >
        <option value="" disabled>Select area</option>
        {areas.map((area) => (
          <option key={area.id} value={area.name}>
            {area.name}
          </option>
        ))}
      </select>
    </div>
  );
};

const styles = {
  container: {
    marginTop: '1rem',
    padding: '1rem',
    width: '100%',
    maxWidth: '400px',
  },
  label: {
    fontSize: '16px',
    marginBottom: '0.5rem',
    display: 'block',
    color: '#333',
  },
  select: {
    width: '100%',
    height: '40px',
    padding: '0 10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    backgroundColor: '#f9f9f9',
    fontSize: '16px',
  },
};

export default AreaPicker;
